import { ButtonPrimary } from "components/Atoms/Button";
import Modal from "components/modal";
import { useOpenNewContactSidePanel } from "components/SidePanel/contact/NewContactSidePanel";
import { useOpenNewCompanySidePanel } from "components/SidePanel/Company/NewCompanySidePanel";
import React from "react";

interface Props {
  onClose: () => void
  isOpen: boolean
}

const NewAddressBookModal = (props: Props) => {
  const openNewContactSidePanel = useOpenNewContactSidePanel();
  const openNewCompanySidePanel = useOpenNewCompanySidePanel();

  return <Modal
    isOpen={props.isOpen}
    handleClose={props.onClose}
    displayHeader={false}
    gap="small"
  >
    {site.currentEnvironment.functionGroups.artist.enabled && (<div>
      <ButtonPrimary
        style={{ justifyContent: "flex-start" }}
        label={site.currentEnvironment.functionGroups.artist.newLabel}
        onClick={() => {
          openNewCompanySidePanel({ type: "artist", onCreated: () => { }, afterCreate: "displayItemInSidebar" })
          props.onClose();
        }}
        fluid
      />
    </div>)}
    {site.currentEnvironment.functionGroups.venue.enabled && (<div>
      <ButtonPrimary
        style={{ justifyContent: "flex-start" }}
        label={site.currentEnvironment.functionGroups.venue.newLabel}
        onClick={() => {
          openNewCompanySidePanel({ type: "venue", onCreated: () => { }, afterCreate: "displayItemInSidebar" })
          props.onClose()
        }}
        fluid
      />
    </div>)}
    {site.currentEnvironment.functionGroups.promoter.enabled && (<div>
      <ButtonPrimary
        style={{ justifyContent: "flex-start" }}
        label={site.currentEnvironment.functionGroups.promoter.newLabel}
        onClick={() => {
          openNewCompanySidePanel({ type: "promoter", onCreated: () => { }, afterCreate: "displayItemInSidebar" })
          props.onClose()
        }}
        fluid
      />
    </div>)}
    {site.currentEnvironment.company.enabled && (<div>
      <ButtonPrimary
        style={{ justifyContent: "flex-start" }}
        label={site.currentEnvironment.company.newLabel}
        onClick={() => {
          openNewCompanySidePanel({ type: "company", onCreated: () => { }, afterCreate: "displayItemInSidebar" })
          props.onClose()
        }}
        fluid
      />
    </div>)}
    {site.currentEnvironment.contact.enabled && (<div>
      <ButtonPrimary
        style={{ justifyContent: "flex-start" }}
        label={site.currentEnvironment.contact.newLabel}
        onClick={() => {
          openNewContactSidePanel({ onCreated: () => { } })
          props.onClose();
        }}
        fluid
      />
    </div>)}
  </Modal>
};

export default NewAddressBookModal;